// Module
var code = `<section>

  <div class="actions">
    <div class="filters">
      <!-- Branch -->
      <div class="labelled-field labelled-field--long">
        <label for="filter-branch" class="add-on">Branch</label>
        <select id="filter-branch"
                class="form-control"
                ng-disabled="\$ctrl.availableBranches && \$ctrl.availableBranches.length === 1"
                ng-model="\$ctrl.filter.branchId"
                ng-options="branch.id as branch.name for branch in \$ctrl.availableBranches"
                ng-change="\$ctrl.onBranchChange()">
          <option value="" ng-if="\$ctrl.availableBranches && \$ctrl.availableBranches.length > 1">(All branches)</option>
        </select>
      </div>

      <!-- Check registration date -->
      <date-range-picker model="\$ctrl.filter.dateRange"></date-range-picker>

      <!-- Actions -->
      <button ng-click="\$ctrl.onFilterBtnClicked()" class="btn btn-primary btn--filter">
        Filter
      </button>
      <button class="btn btn-primary"
              command-access="BatchValidateInwardCheck"
              ng-disabled="!\$ctrl.isAnyCheckSelected()"
              ng-click="\$ctrl.onValidateClicked()">Validate
      </button>
      <button class="btn btn-success"
              command-access="BatchClearInwardCheck"
              ng-disabled="!\$ctrl.isAnyCheckSelected()"
              ng-click="\$ctrl.onClearClicked()">Clear
      </button>
    </div>
  </div>

  <div ng-if="\$ctrl.filter">
    <selectable-list on-api-ready="\$ctrl.onCheckListApiReady(tableAPI)"
                     columns="\$ctrl.checkListColumns"
                     selectable-column-label="Mark check for validation / clearing"
                     records-per-page="20"
                     get-records-page="\$ctrl.getChecksOnCurrentPage(pageSettings)"
                     on-change="\$ctrl.onCheckSelected(checkedRecords)">
    </selectable-list>

    <div class="validation-result" ng-if="\$ctrl.invalidCheckData || \$ctrl.validCheckData">
      <h2 class="section-header">Validation result</h2>

      <div ng-if="\$ctrl.invalidCheckData && \$ctrl.invalidCheckData.length > 0">
        <div class="alert alert--danger validation-result__table-header">
          Checks with errors:
        </div>

        <dynamic-list
          columns="\$ctrl.invalidCheckColumns"
          data="\$ctrl.invalidCheckData"
          list-type="'ERROR'">
        </dynamic-list>
      </div>

      <div ng-if="\$ctrl.validCheckData && \$ctrl.validCheckData.length > 0">
        <div class="alert validation-result__table-header">
          Valid checks:
        </div>

        <dynamic-list
          columns="\$ctrl.validCheckColumns"
          data="\$ctrl.validCheckData">
        </dynamic-list>
      </div>
    </div>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/batch-clearing-page/batch-clearing/batch-clearing.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;